module.exports = __webpack_public_path__ + "operace-nosu_3_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-nosu_3_before.jpg
// module id = 1134
// module chunks = 0